<form [formGroup]="form">
<!--- Oprettelsesdetaljer --->
  <app-guide-card
    [fullWidth]="fullWidth"
    [valid]="(form.get('detailCharacteristics.meterReadingOccurrence')?.valid || form.get('detailCharacteristics.meterReadingOccurrence')?.disabled) &&
      (form.get('detailCharacteristics.settlementMethod')?.valid || form.get('detailCharacteristics.settlementMethod')?.disabled)"
  >
    <div title>
      {{ 'meteringPoint.create.readingBilling.title' | translate }}
    </div>
    <div description>
      {{ 'meteringPoint.create.readingBilling.description' | translate }}
    </div>
    <div>
      <fieldset formGroupName="detailCharacteristics">
        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.meterReadingOccurrence' | translate }}</label>
          <select appSelect [collection]="meterReadingOccurrenceList" formControlName="meterReadingOccurrence"></select>
        </app-input-group>

        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.settlementMethod' | translate }}</label>
          <select appSelect [collection]="settlementMethodList" formControlName="settlementMethod"></select>
        </app-input-group>
      </fieldset>
    </div>
  </app-guide-card>
</form>
